<style src="./style.scss">
</style>

<script lang="ts">
  import { onMount } from "svelte";

  import Icon from "svelte-icon";

  import Button from "@components/button";

  export let nextPaymentRemainingDays;
  export let nextPaymentDate;
  export let goBack = () => null;
  export let nextStep = () => null;

  import WarningIcon from "@assets/icons/warning.svg";

  function getEndAtFormattedDate() {
    const date = new Date(nextPaymentDate);

    return `${date.toLocaleString("pt-br", {
      day: "2-digit",
    })} de ${date.toLocaleString("pt-br", {
      month: "long",
    })} de ${date.getFullYear()}`;
  }

  function whatsappLink() {
    window.open("https://api.whatsapp.com/send?phone=5511953259744", "_blank");
  }
</script>

<div>
  <h1>Cancelar a assinatura</h1>
  <div class="unsubscribe__contact">
    <div class="unsubscribe__contact__content__info">
      <div class="unsubscribe__contact__content__info__icon">
        <Icon data="{WarningIcon}" size="16px" stroke="transparent" />
      </div>
      Tem certeza? Depois de {getEndAtFormattedDate()}, você não terá mais
      acesso a suas estatísticas, progresso e atividades. Além disso, se você
      mudar de ideia no futuro, você poderá se cadastrar novamente, porém o seu
      progresso de aprendizado atual não estará disponível.
    </div>

    <div class="unsubscribe__buttons">
      <div>
        <Button title="Manter minha assinatura" onClick="{goBack}" />

        <div>
          <span>
            Você tem <b>{nextPaymentRemainingDays} dias restantes</b> para aproveitar
            seus benefícios no CNA Go até a próxima cobrança.
          </span>
        </div>
      </div>

      <div>
        <Button title="Falar pelo WhatsApp" onClick="{whatsappLink}" />

        <div>
          <span>
            Atendimento de segunda-feira a sexta-feira das 09:00 às 18:00.
          </span>
        </div>
      </div>

      <div>
        <Button
          title="Continuar cancelamento"
          type="secondary"
          onClick="{nextStep}" />
        <div>
          <span>
            <a target="_blank" href="https://cnago.app/termos/"
              >Contrato e Termos de uso CNA Go</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
